"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _reactAccessibleAccordion = require("react-accessible-accordion");
var _aos = _interopRequireDefault(require("aos"));
var _UNSAFE_AccordionItem = _interopRequireDefault(require("./UNSAFE_AccordionItem"));
var _excluded = ["items", "multiExpand", "shouldAnimate", "delayInterval", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_25jrxidfb3() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Accordion.tsx";
  var hash = "48dbff2d7bcab0ecc2dd13966fc1b6ced40fd836";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_Accordion.tsx",
    statementMap: {
      "0": {
        start: {
          line: 28,
          column: 30
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "1": {
        start: {
          line: 33,
          column: 33
        },
        end: {
          line: 33,
          column: 52
        }
      },
      "2": {
        start: {
          line: 43,
          column: 57
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "3": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 7
        }
      },
      "4": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 45
        }
      },
      "5": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 18
        }
      },
      "6": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 94,
          column: 6
        }
      },
      "7": {
        start: {
          line: 72,
          column: 41
        },
        end: {
          line: 72,
          column: 56
        }
      },
      "8": {
        start: {
          line: 72,
          column: 69
        },
        end: {
          line: 72,
          column: 73
        }
      },
      "9": {
        start: {
          line: 76,
          column: 51
        },
        end: {
          line: 80,
          column: 11
        }
      },
      "10": {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 91,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 22
          },
          end: {
            line: 33,
            column: 23
          }
        },
        loc: {
          start: {
            line: 33,
            column: 33
          },
          end: {
            line: 33,
            column: 52
          }
        },
        line: 33
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        loc: {
          start: {
            line: 53,
            column: 29
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 53
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 33
          },
          end: {
            line: 54,
            column: 34
          }
        },
        loc: {
          start: {
            line: 54,
            column: 39
          },
          end: {
            line: 56,
            column: 5
          }
        },
        line: 54
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 18
          },
          end: {
            line: 95,
            column: 3
          }
        },
        line: 59
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 17
          },
          end: {
            line: 65,
            column: 18
          }
        },
        loc: {
          start: {
            line: 65,
            column: 23
          },
          end: {
            line: 65,
            column: 25
          }
        },
        line: 65
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 72,
            column: 34
          },
          end: {
            line: 72,
            column: 35
          }
        },
        loc: {
          start: {
            line: 72,
            column: 41
          },
          end: {
            line: 72,
            column: 56
          }
        },
        line: 72
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 72,
            column: 62
          },
          end: {
            line: 72,
            column: 63
          }
        },
        loc: {
          start: {
            line: 72,
            column: 69
          },
          end: {
            line: 72,
            column: 73
          }
        },
        line: 72
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 75,
            column: 19
          },
          end: {
            line: 75,
            column: 20
          }
        },
        loc: {
          start: {
            line: 75,
            column: 36
          },
          end: {
            line: 92,
            column: 9
          }
        },
        line: 75
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 30
          }
        }, {
          start: {
            line: 55,
            column: 34
          },
          end: {
            line: 55,
            column: 44
          }
        }],
        line: 55
      },
      "1": {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 63,
            column: 22
          },
          end: {
            line: 63,
            column: 27
          }
        }],
        line: 63
      },
      "2": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 64,
            column: 22
          },
          end: {
            line: 64,
            column: 25
          }
        }],
        line: 64
      },
      "3": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 65,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 65,
            column: 17
          },
          end: {
            line: 65,
            column: 25
          }
        }],
        line: 65
      },
      "4": {
        loc: {
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 91,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 12
          },
          end: {
            line: 88,
            column: 14
          }
        }, {
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 90,
            column: 68
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "48dbff2d7bcab0ecc2dd13966fc1b6ced40fd836"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25jrxidfb3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25jrxidfb3();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AnimatedAccordionItem = (cov_25jrxidfb3().s[0]++, /*#__PURE__*/(0, _base["default"])(_UNSAFE_AccordionItem["default"], process.env.NODE_ENV === "production" ? {
  target: "e83j6rd0"
} : {
  target: "e83j6rd0",
  label: "AnimatedAccordionItem"
})("opacity:0;transition-property:opacity,transform;transition-duration:0.4s;transition-timing-function:ease;transition-delay:", function (props) {
  cov_25jrxidfb3().f[0]++;
  cov_25jrxidfb3().s[1]++;
  return props.delayInterval;
}, "s;transform:translate3d(0, 100px, 0);&.aos-animate{opacity:1;transform:translateZ(0);}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
/** @deprecated  */
var UNSAFE_Accordion = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UNSAFE_Accordion, _React$PureComponent);
  function UNSAFE_Accordion() {
    _classCallCheck(this, UNSAFE_Accordion);
    return _callSuper(this, UNSAFE_Accordion, arguments);
  }
  _createClass(UNSAFE_Accordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      cov_25jrxidfb3().f[1]++;
      cov_25jrxidfb3().s[3]++;
      window.requestAnimationFrame(function () {
        cov_25jrxidfb3().f[2]++;
        cov_25jrxidfb3().s[4]++;
        (cov_25jrxidfb3().b[0][0]++, _this.props.shouldAnimate) && (cov_25jrxidfb3().b[0][1]++, _aos["default"].init());
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_25jrxidfb3().f[3]++;
      var _ref = (cov_25jrxidfb3().s[5]++, this.props),
        items = _ref.items,
        multiExpand = _ref.multiExpand,
        _ref$shouldAnimate = _ref.shouldAnimate,
        shouldAnimate = _ref$shouldAnimate === void 0 ? (cov_25jrxidfb3().b[1][0]++, false) : _ref$shouldAnimate,
        _ref$delayInterval = _ref.delayInterval,
        delayInterval = _ref$delayInterval === void 0 ? (cov_25jrxidfb3().b[2][0]++, 0.3) : _ref$delayInterval,
        _ref$onChange = _ref.onChange,
        onChange = _ref$onChange === void 0 ? (cov_25jrxidfb3().b[3][0]++, function () {
          cov_25jrxidfb3().f[4]++;
        }) : _ref$onChange,
        accordionItemProps = _objectWithoutProperties(_ref, _excluded);
      cov_25jrxidfb3().s[6]++;
      return /*#__PURE__*/_react["default"].createElement(_reactAccessibleAccordion.Accordion, {
        allowMultipleExpanded: multiExpand,
        allowZeroExpanded: true // true allow users to close any open group
        ,
        preExpanded: items.filter(function (i) {
          cov_25jrxidfb3().f[5]++;
          cov_25jrxidfb3().s[7]++;
          return i.startExpanded;
        }).map(function (i) {
          cov_25jrxidfb3().f[6]++;
          cov_25jrxidfb3().s[8]++;
          return i.id;
        }),
        onChange: onChange
      }, items.map(function (item, index) {
        cov_25jrxidfb3().f[7]++;
        var commonProps = (cov_25jrxidfb3().s[9]++, _objectSpread(_objectSpread({
          index: index
        }, item), accordionItemProps));
        cov_25jrxidfb3().s[10]++;
        return shouldAnimate ? (cov_25jrxidfb3().b[4][0]++, /*#__PURE__*/_react["default"].createElement(AnimatedAccordionItem, _extends({
          key: "item_".concat(index),
          "data-aos": "fade-up",
          "data-aos-delay": "".concat(delayInterval * (index + 1), "s"),
          delayInterval: delayInterval
        }, commonProps))) : (cov_25jrxidfb3().b[4][1]++, /*#__PURE__*/_react["default"].createElement(_UNSAFE_AccordionItem["default"], _extends({
          key: "item_".concat(index)
        }, commonProps)));
      }));
    }
  }]);
  return UNSAFE_Accordion;
}((_react["default"].PureComponent));
_defineProperty(UNSAFE_Accordion, "defaultProps", (cov_25jrxidfb3().s[2]++, {
  alignBody: false,
  alignLeft: false,
  arrowPosition: 'left',
  headingLevel: 3,
  multiExpand: false,
  noBorder: false,
  paddingSize: 5
}));
var _default = exports["default"] = UNSAFE_Accordion;